module.exports = __webpack_public_path__ + "static/img/atomy-renewal.d793bae.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/atomy-renewal.jpg
// module id = bsQ1
// module chunks = 0